module.exports = __webpack_public_path__ + "img/orange_063.af92be67.png";